import { render } from "./TagConfigEditor.vue?vue&type=template&id=04343bb1&scoped=true"
import script from "./TagConfigEditor.vue?vue&type=script&lang=js"
export * from "./TagConfigEditor.vue?vue&type=script&lang=js"

import "./TagConfigEditor.vue?vue&type=style&index=0&id=04343bb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04343bb1"]])

export default __exports__